import { createContext } from "react";

const ModualManagerContext = createContext({});

export default ModualManagerContext;
